export const GatewayType = {
    STRIPE: 1,
    LATITUDE: 2,
    ADYEN: 3
}